export default __webpack_public_path__ + "static/media/mi-megaphone.fef2585c.svg";